import { createClient } from 'contentful'

export default createClient({
	space: '61geg9wy6l6n',
	accessToken: '-29k3bLRf639nFplqwJnOUJvkJo9yZYS1jzrslij_qk'
})
